namespace Portico.Models.Setup {

    export interface IDataRow {
		id: string;
		dataTableId: string;
		dataGroupId: string;
		key: string;
		createdBy: number;
		createdOn: Date;
        dataValues: DataValue[];

		getDataValue(dataColumnId: string): DataValue;
		getValue(dataColumnId: string, def?: string): string;
    }

    export class DataRow implements IDataRow {
		id: string;
		dataTableId: string;
		dataGroupId: string;
        key: string;
		createdBy: number;
		createdOn: Date;
        dataValues: DataValue[];

        constructor(obj?: IDataRow) {
            this.id = null;
            this.dataTableId = null;
            this.dataGroupId = null;
            this.key = null;
			this.createdBy = null;
			this.createdOn = null;
            this.dataValues = [];

            if (obj) {
                this.id = obj.id;
                this.dataTableId = obj.dataTableId;
                this.dataGroupId = obj.dataGroupId;
				this.key = obj.key;
				this.createdBy = obj.createdBy;
				this.createdOn = obj.createdOn ? new Date(typeof obj.createdOn === 'string' && (<string>obj.createdOn).charAt(10) === 'T' ? obj.createdOn + 'Z' : obj.createdOn) : null;

                if (obj.dataValues) {
                    for (const dataValue of obj.dataValues) {
                        this.dataValues.push(new DataValue(dataValue));
                    }
                }
            }
        }

		getDataValue(dataColumnId: string): DataValue {
            const matches = this.dataValues.filter((dv: DataValue) => {
                return dv.dataColumnId === dataColumnId;
            });

            return matches && matches.length > 0 ? matches[0] : null;
        }

		getValue(dataColumnId: string, def: string = null): string {
			const dataValue = this.getDataValue(dataColumnId);
			return dataValue ? dataValue.value : def;
		}
    }
}